import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id A673515F-F8A6-41DC-9CB2-05C315FBDA53
 * name arrow-projectile
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-projectile.svg
 * tags
 * - Gaming / RPG 
 * - Sport 
 */
export const ArrowProjectileIcon = createSvgIcon(<><path d="M22 2L20 7L19.03 6.03L8 17.06V19L5 22L4 20L2 19L5 16H6.94L17.97 4.97L17 4L22 2Z" /></>, 'ArrowProjectileIcon');
export default ArrowProjectileIcon